module.exports = __webpack_public_path__ + "media/images/icon/icons8-Double Tick-98850a916f4d0423e1370678cfc7bb82.png";